import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import PracticeAreas from "./components/PracticeAreas";
import ProcessSteps from "./components/ProcessSteps";
import StatsCounter from "./components/StatsCounter";
import Partner from "./components/Partner";
import Values from "./components/Values";
import FAQ from "./components/FAQ";
import GeographySection from "./components/GeographySection";
import ConsultationForm from "./components/ConsultationForm";
import LegalNews from "./components/LegalNews";
import Footer from "./components/Footer";
import AnimatedBackground from "./components/AnimatedBackground";
import PrivacyPolicy from "./components/PrivacyPolicy";
import { mockData } from "./mock";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const [legalNews, setLegalNews] = useState([]);

  // Fetch legal news from backend
  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await axios.get(`${API}/legal-news`);
        if (response.data && response.data.length > 0) {
          setLegalNews(response.data);
        }
      } catch (e) {
        console.log('Failed to fetch legal news');
        setLegalNews([]);
      }
    };
    
    fetchNews();
  }, []);

  const scrollToContacts = () => {
    const element = document.getElementById('contacts');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="page-wrapper">
      <AnimatedBackground />
      <Header onContactClick={scrollToContacts} />
      <Hero companyName={mockData.company.shortName} />
      <About 
        title={mockData.about.title}
        description={mockData.about.description}
      />
      <PracticeAreas areas={mockData.practiceAreas} />
      <ProcessSteps />
      <StatsCounter />
      <Values values={mockData.values} />
      <GeographySection />
      <Partner 
        title={mockData.managingPartner.title}
        name={mockData.managingPartner.name}
        bio={mockData.managingPartner.bio}
      />
      <FAQ />
      <ConsultationForm />
      <LegalNews news={legalNews} />
      <Footer company={mockData.company} />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
